module.exports = "textarea {\n  resize: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings-markets/settings-markets.component.scss
// module id = ./src/app/pages/settings-markets/settings-markets.component.scss
// module chunks = main